module.exports = __webpack_public_path__ + "img/paver_h.6079ad01.png";